import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { TagsMutationKeys } from '../../constants'
import { CreatePlayerTagDto, PlayerTagResponse } from '../../types'
import { createPlayerTag } from '../services'

interface CreatePlayerTagParams {
	payload: CreatePlayerTagDto
}

export default function useMutationCreatePlayerTag(
	props?: UseBaseMutationOptions<PlayerTagResponse, CreatePlayerTagParams>,
) {
	return useMutation({
		mutationKey: [TagsMutationKeys.CreateTag],
		mutationFn: (params) => createPlayerTag(params.payload),
		...props,
	})
}
